import { IUpsertComponentCompaniesPayload, IUpsertComponentCompaniesResponse } from 'bom/types';
import { AgGridDataRow } from 'core/types';
import { IJobPart } from 'jobs/types';

export const onRowsReorder =
  (
    reorderJobParts: (
      data: IUpsertComponentCompaniesPayload
    ) => Promise<IUpsertComponentCompaniesResponse>
  ) =>
  async (diffRows: AgGridDataRow[]) => {
    const componentCompanies = diffRows.map((row) => {
      return {
        componentId: row.componentId,
        line: row.line,
      };
    });

    const data = { componentCompanies };

    const { success, componentCompanies: updatedComponentCompanies } = await reorderJobParts(data);

    if (!success || !updatedComponentCompanies) {
      return { success: false, updatedRows: [] };
    }

    // Create a map of componentId -> line from the backend response
    const lineMap = new Map(updatedComponentCompanies.map((cc) => [cc.componentId, cc.line]));

    // Update the diffRows with the correct line numbers from the backend
    const updatedRows = diffRows.map((row) => {
      const jobPart = row as IJobPart;

      return {
        ...jobPart,
        line: lineMap.get(jobPart.componentId) ?? jobPart.line,
      };
    }) as IJobPart[];

    return {
      success: true,
      updatedRows: updatedRows.sort((a, b) => (a.line || 0) - (b.line || 0)),
    };
  };
